/* eslint-disable no-unused-vars */
import { EHttpMethods } from "../../../../enums";
import {
  AUTH_BASE_URL,
  GET_BANKS_INFO,
  GET_TRANSACTION,
  PAYMENT_BASE_URL,
} from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IApiResponse } from "../../models";
import { CHECKOUT_PATH } from "./constants";
import { ICheckoutRequest, ICheckoutResponse } from "./models";

const defaultProvide = () => getToken();

export const getCheckoutId = (
  data: ICheckoutRequest
): Promise<IApiResponse> => {
  const url = `${PAYMENT_BASE_URL}${CHECKOUT_PATH}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, data);
};

export const checkPaymentStatus = (id: string): Promise<ICheckoutResponse> => {
  const url = `${PAYMENT_BASE_URL}${id}/status`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const checkUserBank = (userId): Promise<IApiResponse> => {
  const url = `${AUTH_BASE_URL}${GET_BANKS_INFO(userId)}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getTransaction = (page = 0, size = 10): Promise<IApiResponse> => {
  const url = `${PAYMENT_BASE_URL}${GET_TRANSACTION}?page=${page}&size=${size}&sort=createdAt,desc`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getBalance = (): Promise<IApiResponse> => {
  const url = `${PAYMENT_BASE_URL}balances`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};
